// Configuration settings for different environments
const config = {
  // App configurations based on environment
  BHGRE: {
    shortname: 'BHGRE',
    name: 'BHGRE',
    applicationName: 'Greenhouse',
    primaryColor: '#339933',
    secondaryColor: '#1a1a1a',
    loginImage: 'https://static.bhgre.com.au/greenhouse/logins/login-image-01.jpg',
    API_BASE_URL: 'https://api.centernet.com.au/earthquakeapi/v1/BHGRE',
    noListingImage: 'https://static.bhgre.com.au/logo-assets/no-property-photo.png',
    OFIURL: 'https://ofi.bhgre.com.au/',
    OFILogo:'https://static.bhgre.com.au/logo-assets/Bug_Green_RGB_trim.fw.png'
  },
  
  C21: {
    shortname: 'C21',
    name: 'Century 21',
    primaryColor: '#c8a876', 
    secondaryColor: '#1a1a1a', 
    applicationName: 'eSales',
    loginImage: 'https://static.century21.com.au/esales-admin-images/city-scape-01.jpg',
    API_BASE_URL: 'https://api.centernet.com.au/earthquakeapi/v1/C21',
    noListingImage: 'https://static.century21.com.au/broadcasts/no-property-photo.png',
    OFIURL: 'https://ofi.c21.com.au/',
    OFILogo:'https://static.century21.com.au/logo-assets/c21-seal.png'
  }
};

export const getCurrentConfig = () => {
  let appType = import.meta.env.VITE_APP_CONFIG;
  

  if (!appType && typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('bhgre.com.au')) {
      appType = 'BHGRE';
    } else {
      appType = 'C21';
    }
    appType = appType;
  }

  return config[appType];
};

export default config;
